document.addEventListener("DOMContentLoaded", function () {
  // Check if the element with class "js-responsive-table" exists
  if (!document.querySelector(".js-responsive-table")) {
    // If it does not exist, exit the function and do not execute the rest of the code
    return;
  }

  function AddTableARIA() {
    try {
      var allTables = document.querySelectorAll("table");
      for (var i = 0; i < allTables.length; i++) {
        allTables[i].setAttribute("role", "table");
      }
      var allRowGroups = document.querySelectorAll("thead, tbody, tfoot");
      for (var i = 0; i < allRowGroups.length; i++) {
        allRowGroups[i].setAttribute("role", "rowgroup");
      }
      var allRows = document.querySelectorAll("tr");
      for (var i = 0; i < allRows.length; i++) {
        allRows[i].setAttribute("role", "row");
      }
      var allHeaders = document.querySelectorAll("th");
      for (var i = 0; i < allHeaders.length; i++) {
        allHeaders[i].setAttribute("role", "columnheader");
      }
      var allCells = document.querySelectorAll("td");
      for (var i = 0; i < allCells.length; i++) {
        allCells[i].setAttribute("role", "cell");
      }
      // this accounts for scoped row headers
      var allRowHeaders = document.querySelectorAll("th[scope=row]");
      for (var i = 0; i < allRowHeaders.length; i++) {
        allRowHeaders[i].setAttribute("role", "rowheader");
      }
      // caption role not needed as it is not a real role and
      // browsers do not dump their own role with display block

      var headerValues = []; // Array per memorizzare i testi delle intestazioni
      
      // Ciclo che raccoglie i testi delle intestazioni
      for (var i = 0; i < allHeaders.length; i++) {
        allHeaders[i].setAttribute("role", "columnheader");
        headerValues.push(allHeaders[i].textContent);
      }

      for (var i = 0; i < allCells.length; i++) {
        // Usa l'array headerValues per assegnare "data-colHead" a tutte le celle di ogni riga
        allCells[i].setAttribute("role", "cell");
        allCells[i].setAttribute("data-colHead", headerValues[i % headerValues.length]);
      }

    } catch (e) {
      console.log("AddTableARIA(): " + e);
    }
  }
  
  AddTableARIA();
  
  const allRows = document.querySelectorAll("tbody > tr");
  const offcanvas = document.getElementById("responsive-table-offcanvas");

  // Verifica se l'offcanvas esiste prima di eseguire il codice relativo
  if (offcanvas) { 
    // Funzione per costruire offcanvasData in base ai <th> della tabella
    function buildOffcanvasData() {
      // const headers = document.querySelectorAll(".o-rspnsv-table th");
      const headers = document.querySelectorAll(".o-rspnsv-table th");
      return Array.from(headers).map(th => {
        return { title: th.textContent.trim(), slots: 1 }; // Assumendo un solo slot per ogni titolo
      });
    }

    // Funzione per costruire dl
    function buildOffcanvasList() {
      const offcanvasData = buildOffcanvasData();
      const dl = document.getElementById("offcanvas-list");
      let html = '';
      let slotCounter = 1;

      offcanvasData.forEach(item => {
        html += `<dt>${item.title}</dt>`;
        for (let i = 0; i < item.slots; i++) {
          html += `<dd id="slot-${slotCounter}"></dd>`;
          slotCounter++;
        }
      });

      dl.innerHTML = html;
    }

    buildOffcanvasList(); // Costruisci <dl> all'avvio

    function populateAndToggleOffcanvas(row) {
      const columns = Array.from(row.children);

      columns.forEach(function (child, i) {
        const id = `slot-${i + 1}`;
        const cellContent = child.innerText.trim();
        // document.getElementById(id).innerHTML = child.innerText;
        // Se la cella è vuota, usa "---" come contenuto, altrimenti usa il testo della cella
        document.getElementById(id).innerHTML = cellContent === '' ? '---' : cellContent;
      });

      // Se il pannello è già aperto, chiudilo prima di riaprirlo
      if (offcanvas.classList.contains("is-active")) {
        offcanvas.classList.remove("is-active");
        // Aggiungi un breve ritardo prima di riaprire per rendere l'interazione visibile
        setTimeout(function() {
          offcanvas.classList.add("is-active");
        }, 300);
      } else {
        offcanvas.classList.add("is-active");
      }

      offcanvas.removeAttribute("aria-hidden");
      offcanvas.querySelector("button").tabIndex = undefined;
      offcanvas.focus();
    }
    
    function closeOffcanvas() {
      offcanvas.setAttribute("aria-hidden", "true");
      offcanvas.classList.remove("is-active");
      offcanvas.querySelector("button").tabIndex = -1;
      document.getElementById("responsive-table-wrapper").focus();
    }
    
    allRows.forEach(function (row) {
      row.addEventListener("click", function() {
        populateAndToggleOffcanvas(row);
      });
    });

    var closeButton = document.querySelector(".js-rspnsv-table-offcanvas-close-btn");
    closeButton.addEventListener("click", function () {
      closeOffcanvas();
    });
  }

});
